

    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../controlador';
    import { Item } from '@/__env/lib/Ventas/Pedidos/Item';
    import { Observacion } from '@/__env/lib/Ventas/Pedidos/Observaciones';
    import { Wait } from '@/__env/ext';
    import { utimes } from 'fs';
    import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Cliente() { return this.Controlador.Pedido.Cliente; }
        public get Envio() { return this.Controlador.Pedido.Envio; }

        public Focused: boolean = false;
        public Cargando: boolean = false;
        public Observaciones: Observacion[] = [];

        public Observacion: string = '';
        public EnviarAPlataforma: boolean = false;

        async mounted()
        {
            this.Cargando = true;
            await Wait( 2000 );
            this.Observaciones.clear();
            this.Observaciones = await this.Pedido.CargarObservaciones();
            this.Cargando = false;
            this.$nextTick( () => Utiles.ElementScrollBottom( document.getElementById( 'div-observaciones' ) ) );
        }

        Cerrar()
        {
            this.Focused = false;
        }

        async Enviar()
        {
            if ( this.Observacion )
            {
                let o = this.Observacion;
                this.Observacion = '';
                let ob = new Observacion();
                ob.Observacion = o;
                ob.Pedido = this.Pedido.Id;
                if ( await ob.save( this.EnviarAPlataforma ) )
                {
                    this.EnviarAPlataforma = false;
                    this.Observaciones.push( ob );
                    this.$nextTick( () => Utiles.ElementScrollBottom( document.getElementById( 'div-observaciones' ) ) );
                }
                else
                {
                    Utiles.Notificaciones.Error( 'Error al enviar la observación' );
                }
            }
        }
    }
